module.exports = __webpack_public_path__ + "static/media/ic_screeshare_zoomout.936d857f.svg";